import { useEffect, useRef, type ReactNode } from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(26, 26, 26, .45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: auto;
  padding: 30px 16px;
  z-index: 10;
  @media (max-width: 640px) { padding: 8px; align-items: stretch; }
`;

const Laatikko = styled.div<{ $leveys: string }>`
  background: ${p => p.theme.color.bg};
  border-radius: ${p => p.theme.radius.xl};
  max-width: ${p => p.$leveys};
  width: 100%;
  padding: 20px;
  position: relative;
`;

const Sulje = styled.button`
  position: absolute;
  top: 10px;
  right: 14px;
  font-size: 22px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${p => p.theme.color.muted};
  line-height: 1;
  z-index: 3;
`;

interface Props {
  onClose: () => void;
  children: ReactNode;
  leveys?: string;
}

/** Taustan klikkaus ja Esc sulkevat — kuten vanhassa liidi-ikkunassa. */
export function Modal({ onClose, children, leveys = '1060px' }: Props) {
  const suljeRef = useRef(onClose);
  suljeRef.current = onClose;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') suljeRef.current(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <Overlay onMouseDown={e => { if (e.target === e.currentTarget) suljeRef.current(); }}>
      <Laatikko $leveys={leveys} onMouseDown={e => e.stopPropagation()}>
        <Sulje type="button" onClick={() => suljeRef.current()} aria-label="Sulje">×</Sulje>
        {children}
      </Laatikko>
    </Overlay>
  );
}
